import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { MdfRequestComment } from "./types";

// GET /api/admin/mdf/requests/:id/comments → { comments: MdfRequestComment[] }
//
// Sub-bucket 15 — drawer comments thread. Returns both partner and internal
// comments (the GET handler doesn't filter author_role); the drawer styles
// the two roles differently. Optimistic appends via
// useAddInternalMdfComment write to the same query key
// (`queryKeys.mdf.requestComments(id)`) so the thread updates synchronously.
export function useMdfRequestComments(id: string | null | undefined) {
  return useQuery<MdfRequestComment[], ApiClientError>({
    queryKey: queryKeys.mdf.requestComments(id ?? ""),
    queryFn: async () => {
      const body = await apiFetch<{ comments: MdfRequestComment[] }>(
        `/admin/mdf/requests/${id}/comments`,
      );
      return body.comments;
    },
    enabled: !!id,
  });
}
